module.exports = __webpack_public_path__ + "img/tlaxcala.7dc9aa86.png";